module.exports = __webpack_public_path__ + "img/w19-b2.95a8dd9e.jpg";